import { FC, ReactElement } from "react"

export const MemberSkills: FC<any> = ():ReactElement => {

    return(
        <></>
    )
    
}